var _defs, _title, _path, _g, _rect, _rect2, _rect3, _path2, _path3, _polygon, _path4, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _circle, _circle2, _circle3, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _g2, _path45, _polygon3, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _rect4, _rect5, _rect6, _path53, _circle4, _circle5, _path54, _path55, _path56, _rect7, _path57, _path58, _path59;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBeforeYouLeave = function SvgBeforeYouLeave(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 240 170",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.6,22.2C85.7-7.5,211.3,4,208.6,54.1c-2.4,42.2,18.3,44.1,8.9,75.6-10,33.8-122.2,45.9-171,17.1S27.3,44.8,52.6,22.2Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -57.32,
    y1: 225.34,
    x2: -57.32,
    y2: 182.77,
    gradientTransform: "translate(225.3 -160.7) rotate(13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98aab6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9aacb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#a3b3be"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#b1bec8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#c5ced7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#dee3e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e6ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -126.63,
    y1: 276.13,
    x2: 1.08,
    y2: 276.13,
    gradientTransform: "translate(376 155.9) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcf3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#d1d7d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#9babb0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#718993"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#52707f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#406172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#395c6e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -57.6,
    cy: 270.96,
    r: 49.45,
    gradientTransform: "matrix(0, 1, -0.6, 0, 268.63, 146.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#bbc7d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#aebdc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#a2b2bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#9aacb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#98aab6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#9caeb9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#a9b8c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#bbc7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -97.24,
    y1: 281.59,
    x2: -72.73,
    y2: 226.53,
    gradientTransform: "translate(225.3 -160.7) rotate(13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fff4d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#fff5d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#fffaeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fffcf3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -22.15,
    y1: 308.55,
    x2: -22.15,
    y2: 271.71,
    gradientTransform: "translate(225.3 -160.7) rotate(13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f1bb9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7d5be"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -22.8,
    y1: 278.86,
    x2: -22.8,
    y2: 273.03,
    gradientTransform: "translate(225.3 -160.7) rotate(13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#f0af88"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#eea37a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -20.55,
    y1: 258.71,
    x2: 1.3,
    y2: 258.71,
    gradientTransform: "translate(225.3 -160.7) rotate(13.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fbe7ab"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#fbe197"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fcd875"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#fdd260"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#fdd058"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -2446.72,
    y1: 604.14,
    x2: -2424.87,
    y2: 604.14,
    gradientTransform: "translate(-2370.9 50.5) rotate(-165.5)",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 39.06,
    y1: 312.34,
    x2: 39.06,
    y2: 300.09,
    gradientTransform: "translate(239.4 -219.2) rotate(14.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eea37a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#ea9163"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e7824f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 25.16,
    y1: 312.34,
    x2: 25.16,
    y2: 300.09,
    xlinkHref: "#k"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 103.06,
    y1: 125.22,
    x2: 126.39,
    y2: 125.22,
    gradientTransform: "translate(92.7 -85.9) rotate(4.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#98aab6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#afbdc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#bbc7d0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 21.35,
    y1: 329.55,
    x2: 50.76,
    y2: 329.55,
    gradientTransform: "translate(239.4 -219.2) rotate(14.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#395c6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98aab6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 36.06,
    cy: 331.41,
    r: 4.71,
    gradientTransform: "translate(239.4 -219.2) rotate(14.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#bbc7d0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e2e6ec"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 48.31,
    y1: 357.59,
    x2: 14.02,
    y2: 357.59,
    gradientTransform: "translate(239.4 -219.2) rotate(14.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eea37a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#e7824f"
  })))), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Before You Leave")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.6,22.2C85.7-7.5,211.3,4,208.6,54.1c-2.4,42.2,18.3,44.1,8.9,75.6-10,33.8-122.2,45.9-171,17.1S27.3,44.8,52.6,22.2Z",
    fill: "#fbe7ab"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.6,58.6l-100-24a12.5,12.5,0,0,1-9.2-15l7.4-31L189,18.7l-7.4,30.7A12.4,12.4,0,0,1,166.6,58.6Z",
    fill: "#98aab6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,33a10.8,10.8,0,0,1-8-13l7.4-30.9,121,29.3L180,49a10.8,10.8,0,0,1-13,8Z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.7,33.8,108,7.4l-5-1.2-1.4,5.9,2.1.5-5,20.5S98.9,36.2,101.7,33.8Z",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.1 31.8 139.7 44.3 161.7 47.3 165.2 48.9 167.8 39.6 163.3 40 143.1 31.8",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "144.9 16 130.1 12.5 127 42 126.4 44.3 134.1 46.2 134.8 43.4 144.9 16",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,13.5h-.3l-5.7-1-5,20.7s.2,3.2,4.9,4.5h.3c4.8,1,6.5-1.8,6.5-1.8l4.9-20.7Z",
    fill: "#e2e6ec"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,33.3,64.2,5.1l-.9,3.8h.4L61,20.5A8.7,8.7,0,0,0,64.9,30h0l.2.4.3-.2a5,5,0,0,0,2,.8L167.5,55a8.5,8.5,0,0,0,2.3.3l.2.3.3-.3h0a8.8,8.8,0,0,0,6.8-4.2h.2v-.2a5.4,5.4,0,0,0,.8-2.1l2.8-11.5h0Zm-15.4.3h0l.9,1.5-6.7,4.1-4.1-6.7,1.5-.9h-.1Zm-8.9-2.1-1.2.7-.8-1.2Zm-2.4-.6h-.1l.9,1.4-6.7,4.1L145,29.8l1.5-.9h0Zm-9-2.1-1.2.7-.7-1.2Zm-2.4-.6h-.1l.9,1.5-6.6,4.1-4.1-6.7,1.4-.9h0Zm-9-2.2-1.2.8-.7-1.2Zm-2.3-.5h-.1l.9,1.5-6.7,4.1-4.1-6.7,1.5-.9h-.1Zm-9-2.2-1.2.7-.7-1.2Zm-2.4-.6h-.1l.9,1.5-6.7,4-4-6.6,1.4-.9h0Zm-9-2.1-1.2.7-.7-1.2Zm-2.4-.6h0l.9,1.4-6.7,4.1-4.1-6.7,1.5-.9H101Zm-8.9-2.2-1.2.8-.8-1.2Zm-2.4-.5h-.1l.9,1.5-6.7,4.1-4.1-6.7,1.5-.9h0ZM88,15.9l-.7-1.2,1.9.4Zm-.4.2L81,20.2l-4.1-6.7,1.4-.9h0l8.5,2.1h-.1Zm-9.8-3.7-1.2.7-.7-1.2Zm2.8,8-6.7,4.1-4.1-6.7,6.7-4.1Zm.2.4,4.1,6.6-6.7,4.1-4.1-6.6Zm.4-.3,6.7-4.1L92,23.1l-6.7,4.1Zm11,3,4.1,6.7-6.7,4.1-4.1-6.7Zm.3-.2,6.7-4.1,4.1,6.6-6.7,4.1Zm11,2.9,4.1,6.7L101,37l-4.1-6.7Zm.4-.2,6.7-4.1,4.1,6.7L108,32.7Zm11,2.9,4.1,6.7-6.7,4.1L108.2,33Zm.4-.2,6.6-4.1,4.1,6.7-6.6,4.1Zm11,3,4.1,6.6-6.7,4.1-4.1-6.6Zm.3-.3,6.7-4.1,4.1,6.7-6.7,4.1Zm11,3,4.1,6.7L135,45.2l-4.1-6.7Zm.4-.2,6.7-4.1,4.1,6.6-6.7,4.1Zm11,2.9,4.1,6.7-6.7,4.1-4.1-6.7Zm.3-.2,6.7-4.1,4.1,6.7-6.7,4.1Zm11,2.9,4.1,6.7-6.6,4.1-4.1-6.7Zm.4-.2,6.7-4.1,4.1,6.7-6.7,4.1Zm6.1-5.9,1.9.5-1.2.7ZM75.5,11.8h-.1l.9,1.5-6.7,4-5-8.2ZM61.4,20.6,64.1,9.2l5.1,8.5-8.1,4.9A6.4,6.4,0,0,1,61.4,20.6Zm3.9,9.1a8.1,8.1,0,0,1-4.1-6.6L69.5,18l4.1,6.7Zm2.2.9a4.9,4.9,0,0,1-1.7-.6l8-4.9,4.1,6.7-1.6.9Zm9.4,2.3,1.2-.8.7,1.2Zm2.4.5h.1l-.9-1.5,6.6-4.1,4.1,6.7-1.5.9h.1Zm8.9,2.2,1.3-.8.7,1.3Zm2.4.6h.1l-.9-1.5,6.7-4.1,4.1,6.7-1.5.9h.1Zm9,2.1,1.2-.7.8,1.2Zm2.4.6h.1l-.9-1.5,6.7-4,4.1,6.6-1.5.9h0Zm9,2.1,1.2-.7.7,1.2Zm2.4.6h.1l-1-1.5,6.7-4.1,4.1,6.7-1.5.9h.1Zm8.9,2.2,1.2-.8.8,1.2Zm2.4.5h.1l-.9-1.5,6.7-4.1,4.1,6.7-1.5.9h0Zm9,2.2,1.2-.8.7,1.3Zm2.4.6h.1l-.9-1.5,6.6-4.1,4.1,6.7-1.5.9h.1Zm8.9,2.1,1.3-.7.7,1.2Zm2.4.6h.1l-.9-1.4,6.7-4.1,4.1,6.6-1.5.9h.1Zm9,2.1,1.2-.7.8,1.2Zm11.2,2.7-8.6-2L158,51l6.7-4.1,4.8,8A6.3,6.3,0,0,1,167.6,54.6Zm2.4.2-5-8.1,6.7-4.1,5,8.1A8.1,8.1,0,0,1,170,54.8Zm7.6-6.3a6.7,6.7,0,0,1-.7,1.8l-4.8-8,8.2-5ZM171.8,42l-4.1-6.7,1.5-.9h0l10.9,2.6Z",
    fill: "#bbc7d0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62.1,
    y: 25.4,
    width: 88,
    height: 127.71,
    rx: 12,
    transform: "translate(-5.5 171.6) rotate(-76.5)",
    fill: "#395c6e"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 55.8,
    y: 29.3,
    width: 88,
    height: 127.71,
    rx: 12,
    transform: "translate(-14 168.5) rotate(-76.5)",
    opacity: 0.24,
    fill: "url(#c)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.9,
    y: 29.3,
    width: 80.3,
    height: 119.99,
    rx: 8.3,
    transform: "translate(-5.5 171.6) rotate(-76.5)",
    fill: "#98aab6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 67.5,
    y: 30.9,
    width: 77,
    height: 116.73,
    rx: 7.2,
    transform: "translate(-5.5 171.6) rotate(-76.5)",
    fill: "url(#d)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.3,125.5s4.3,1.7,8.1-12.2,15.2-18.5,16.2-31.2l-1.8-.7s1.9-2.5,2-4.4-17.2-5.6-17.2-5.6l-12,51.9Z",
    fill: "#bbc7d0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1,55.7s18-1.2,30.1,2.3c0,0,.3,23.5-12.7,38.5,0,0-6.9,13.1-8.4,22.8-1.2,7.1-5.5,6.2-5.5,6.2l-16.7-4s3.6-60.9,7.6-65.1C92.8,55,97.1,55.7,97.1,55.7Z",
    fill: "#e2e6ec"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "120.2 89.8 116.1 85.1 116.1 85 118 68 126.3 69.7 126.2 70.1 118.3 68.5 116.6 84.9 120.5 89.5 120.2 89.8",
    fill: "#bbc7d0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101,63.5v-.4c11.9-3.3,25.8.8,25.9.9v.4C126.6,64.3,112.8,60.2,101,63.5Z",
    fill: "#bbc7d0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3,123.9c0-.2-.2-4.6,6.3-21.3s9.5-40.1,9.5-40.4h.5c-.1.2-3.2,23.9-9.6,40.5s-6.3,21-6.3,21Z",
    fill: "#bbc7d0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "108.9 61.9 109.6 55.2 112.7 55.4 112 61.8 111.6 61.7 112.2 55.8 110 55.7 109.3 62 108.9 61.9",
    fill: "#bbc7d0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102,44.3s-1.3-5.6-8.7-4.2l-1.8.4a36.5,36.5,0,0,1-2.6,8.7c-1,2.4-2,4.8-4.6,6.4a37.5,37.5,0,0,1-4.9,2.3c-6.6,2.3-15-5-14.5-11.2-4.4,1.2-7.7,3.8-7.4,6.9a24,24,0,0,1-.2,7s-1.8,23.3,4.3,27.1,13.1.8,10.2,4.2.8,4.1,2.3,2.7,27.1-8.8,27.1-8.8,5.2-1.1,6.9-3.1S102,44.3,102,44.3Z",
    fill: "url(#e)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4,57.9a37.5,37.5,0,0,0,4.9-2.3c2.6-1.6,3.6-4,4.6-6.4a36.5,36.5,0,0,0,2.6-8.7c-6.6,1.8-12.6,5.7-19.5,5.4a23.5,23.5,0,0,0-7.1.8C64.4,52.9,72.8,60.2,79.4,57.9Z",
    fill: "#e2e6ec"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6,41s-.1,13.8-11.9,15.3C67.5,57.7,66.4,46,66.4,46l-4.2,1.3s4,15.1,16.8,12.3,11.9-8,14.3-19.5Z",
    fill: "#f1bb9a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5,56.7c7.9-1.7,8.5-1.4,15.6-2.5-.3-1.3-.5-2.6-.7-3.7L87.1,53.9,88.6,51l14.3-3-.8-3.9-.3-.7.2.9L90.5,46.8l1-2.7,9.4-2.1c-1.1-1.4-3.3-2.8-7.5-2C86,41.4,79.6,46.1,72,45.7s-12.6,2.2-14.1,5.7L64.2,50l.6,2.4L57.6,54a24.2,24.2,0,0,1,0,2.7l11.2-2.4.5,2.5L57.5,59.3c-.1.7-.2,1.1-.2,1.1s-.1,1.1-.1,2.9c5.8-1.3,7-.4,14.5-2S80,58.5,88.5,56.7Z",
    fill: "none"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8,84.7c8-1.7,8.9-1.4,15.4-2.4a8.7,8.7,0,0,0,0-3.3c-6.5,1.4-7.6.5-15.6,2.2S83.8,84.1,74.9,86a103.3,103.3,0,0,1-12.7,1.9c4,2.2,8.2,1.8,9.7,2.2l3.5-.7C84.2,87.5,84,86.6,92.8,84.7Z",
    fill: "none"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2,87.2c-9,1.9-8.8,2.9-17.7,4.8l-4.4.8c-1.4,2.5,1.7,2.9,3,1.6s19-6.4,25.1-8.2Z",
    fill: "none"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1,64.1c8-1.7,8.9-1.4,15.4-2.4q-.4-2.6-.9-4.8c-7,1.6-7.8.6-15.8,2.3S80.4,62,71.7,63.8s-8.5,1.4-14.6,2.4V71c6.6-1.5,7.6-.5,15.6-2.2S81.3,65.9,90.1,64.1Z",
    fill: "none"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M92.2,78.7c8.1-1.7,8.9-1.4,15.7-2.5-.2-1.3-.4-2.8-.6-4.4-6.6,1.5-7.6.6-15.7,2.3s-8.7,2.8-17.7,4.7S65,80.2,58.3,81.2a12.8,12.8,0,0,0,1.5,4.3c6-1.3,7.3-.5,15-2.1S83.4,80.5,92.2,78.7Z",
    fill: "none"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3,71.5c8-1.7,8.8-1.4,15.5-2.4-.2-1.5-.5-3.1-.8-4.7-6.4,1.4-7.5.5-15.5,2.2s-8.8,2.9-17.7,4.8-9,1.4-15.5,2.4a39.1,39.1,0,0,0,.5,4.8c7-1.7,7.9-.6,16.1-2.3S82.5,73.4,91.3,71.5Z",
    fill: "none"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5,46.8,102,44.3l-.2-.9a4.6,4.6,0,0,0-.9-1.4l-9.4,2.1Z",
    fill: "#f1bb9a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2,50l-6.3,1.4a4.8,4.8,0,0,0-.4,2c0,.2.1.4.1.6l7.2-1.6Z",
    fill: "#f1bb9a"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1,53.9l16.3-3.4c-.2-.9-.4-1.8-.5-2.5L88.6,51Z",
    fill: "#f1bb9a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8,54.3,57.6,56.7a17.8,17.8,0,0,1-.1,2.6l11.8-2.5Z",
    fill: "#f1bb9a"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8,59.2c8-1.7,8.8-.7,15.8-2.3-.2-1-.3-1.8-.5-2.7-7.1,1.1-7.7.8-15.6,2.5s-8.3,2.7-16.8,4.6-8.7.7-14.5,2a26.2,26.2,0,0,0-.1,2.9c6.1-1,7-.7,14.6-2.4S80.2,61,88.8,59.2Z",
    fill: "#f1bb9a"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M90.5,66.6c8-1.7,9.1-.8,15.5-2.2a25.6,25.6,0,0,0-.5-2.7c-6.5,1-7.4.7-15.4,2.4s-8.6,2.8-17.4,4.7-9,.7-15.6,2.2c0,.9.1,1.8.2,2.8,6.5-1,7.5-.8,15.5-2.4S81.5,68.5,90.5,66.6Z",
    fill: "#f1bb9a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6,74.1c8.1-1.7,9.1-.8,15.7-2.3-.2-.8-.3-1.7-.5-2.7-6.7,1-7.5.7-15.5,2.4s-8.6,2.9-17.4,4.8-9.1.6-16.1,2.3a20,20,0,0,0,.5,2.6c6.7-1,7.6-.7,15.6-2.4S82.7,76,91.6,74.1Z",
    fill: "#f1bb9a"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M92.6,81.2c8-1.7,9.1-.8,15.6-2.2-.1-.8-.2-1.8-.3-2.8-6.8,1.1-7.6.8-15.7,2.5s-8.6,2.8-17.4,4.7-9,.8-15,2.1a4.9,4.9,0,0,0,1.9,2.1l.5.3A103.3,103.3,0,0,0,74.9,86C83.8,84.1,83.6,83.1,92.6,81.2Z",
    fill: "#f1bb9a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2,87.2l6-1,2-.6s5.3-1,6.9-3a.4.4,0,0,0,.1-.3c-6.5,1-7.4.7-15.4,2.4s-8.6,2.8-17.4,4.7l-3.5.7c.7.2.8.6-.1,1.7l-.7,1,4.4-.8C84.4,90.1,84.2,89.1,93.2,87.2Z",
    fill: "#f1bb9a"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M151.1,108.3l-.6-4.4s-1.9-4-10.7-5.7-12.4,1.9-12.4,1.9l-2.2,3-6.3.2s-1.9.7-3.2,5-4.2,17.5-4.2,17.5a2.4,2.4,0,0,0,1,3.3c2.1,1.4,36.7,8.8,36.7,8.8s3.4,2.2,4.6-2.6l4.9-20.6s.2-2.1-2.4-3.7S151.1,108.3,151.1,108.3Z",
    fill: "url(#f)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137.2,
    cy: 108.4,
    r: 0.9,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 134.5,
    cy: 122.7,
    r: 0.9,
    fill: "#fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 131.8,
    cy: 133.7,
    r: 0.9,
    fill: "#fff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M137.8,123.9a10.8,10.8,0,0,1,3.7.7,6.8,6.8,0,0,1,4.6,5.2v.5l.3-.4c.1-.2,2.9-3.7,9-1.8v-.4c-5.3-1.6-8.3.7-9.2,1.6-1.4-5.5-7.5-5.8-8.5-5.9l2.5-10.2a3.4,3.4,0,0,0,1.5.6c2.8.7,6.5-.5,6.7-.5a8.3,8.3,0,0,0,2.2-1.6l7.7,3.9v-.4l-7.5-3.8a2.2,2.2,0,0,0,.5-2.1l-.9-4.9h-.2c-3.1,1.2-9.3,1-10.3,1l-1.4-.5a3,3,0,0,0-3.2,1.1l-1.1-1.7h-.2a7.5,7.5,0,0,1-6.7-4.5l-.3.4a5.8,5.8,0,0,0,1.4,2,8.3,8.3,0,0,0,5.4,2.5c0,.7-.1,3.5-1.5,4.9a3.1,3.1,0,0,1-2.5.8c-4.2-.4-4.7-7.4-4.7-7.4h-.5a17.2,17.2,0,0,0,.4,2.2H117l-.3.4h8.7l.3,1.1c.9,2.2,2.1,3.6,3.8,4h.6a3.4,3.4,0,0,0,2.8-.9,7.2,7.2,0,0,0,1.6-4.7l.8,1.2-.4.9c-.6,1.5-2.1,8.3-3.4,14.5-5.3-1.6-8.2.8-9.1,1.6a7.7,7.7,0,0,0-4.9-5.2,12.5,12.5,0,0,0-4-1v.4c.1,0,7.4.4,8.7,6.3v.5l.3-.4s2.8-3.6,8.9-1.8c-.6,2.9-1.2,5.6-1.6,7.7l-18.2-4.4v.4l18.2,4.4c-.3,1.8-.6,2.9-.6,3.1h.4c.1-.3,4.7-23.1,5.8-26.1s3.3-2.1,3.4-2.1l1.1.4-1,3.3a4.3,4.3,0,0,0,1.2,3.8l-5.2,21.9h.3l.8-2.9,17.7,4.2v-.4L136,131.4Zm2.5-11.3a3.7,3.7,0,0,1-1-3.4l.9-3.3h.2c1.5.1,6.9.1,10-.9l.8,4.4h0c0,.1.5,1.8-2.7,3.5C148.4,112.9,142.8,114.6,140.3,112.6Z",
    fill: "#e7824f"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M128.5,101.3s2.7-3.5,10.6-1.9c10.5,2.2,9.4,5.5,9.4,5.5a17.7,17.7,0,0,1-10.1-.4C133.5,102.7,134.7,106,128.5,101.3Z",
    fill: "url(#g)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1,71.3h.1c.6-.8.4-1.8-1.1-2.6,0,0-19.8-7.3-32.5-6.1l-.7,3.8C129.8,66.3,144.2,64.2,163.1,71.3Z",
    fill: "#fff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1,71.3c-18.9-7.1-33.3-5-34.2-4.9-.7,4.1-1.6,10.3-1,13.6,0,0,.6-3.4,1.5-3.6s6,.9,9,1.8,2,6.2,2,6.2-.8,1.6.7,1.6,2.2-6.6,2.2-6.6,7.2-6.7,12.4-6c3.2.5,6.5-.7,7.5-2.1Z",
    fill: "#fdd058"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M138.4,78.2c-3-.9-8.2-2-9-1.8s-1.5,3.6-1.5,3.6,11.3,5.6,12.5,4.4S141.4,79,138.4,78.2Z",
    fill: "#fbe7ab"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M141.7,75.6s.7,7.5,5.5,7.1-3-7-3-7l-.7.8s4.6,4,3.5,4.7-3.7-2.8-4.3-6.4Z",
    fill: "#fff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.3,74.3s4.7-1.1,7.2,1.9-6.3.6-7.9.2c-.1,0-.1-.1,0-.2V74.9s6.4,2.5,6.6,1.5-6.8-1.3-6.8-1.3Z",
    fill: "#fff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M150.5,75s-1.2-3.4-2-2.8,1,3.6,1,3.6S150.5,76.6,150.5,75Z",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M147.3,75.4s-1.2-3.3-2-2.7,1,3.5,1,3.5S147.3,77,147.3,75.4Z",
    fill: "#fff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M153.1,74.3s-1.2-3.4-2-2.8,1,3.6,1,3.6S153.1,75.9,153.1,74.3Z",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M130.9,90.8h-.1c-.6.8-.4,1.8,1.1,2.6s19.8,7.2,32.4,6c0,0,.4-1.5.8-3.8C164.2,95.9,149.8,98,130.9,90.8Z",
    fill: "#fff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M130.9,90.8c18.9,7.2,33.3,5.1,34.2,4.9.7-4,1.6-10.3,1-13.6,0,0-.7,3.5-1.5,3.7s-6-1-9-1.8-2-6.2-2-6.2.8-1.7-.7-1.6-2.2,6.6-2.2,6.6-7.2,6.7-12.4,6c-3.2-.5-7.3-.4-7.5,2.1Z",
    fill: "#fdd058"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M155.6,84c3,.8,8.1,1.9,9,1.8s1.5-3.7,1.5-3.7-11.3-5.5-12.5-4.3S152.6,83.1,155.6,84Z",
    fill: "#fbe7ab"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5,87.2s1.2,3.4,2,2.7-1-3.5-1-3.5S143.5,85.6,143.5,87.2Z",
    fill: "#fff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M146.1,85.6s1.2,3.4,2,2.8-1-3.6-1-3.6S146.1,84,146.1,85.6Z",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M148.7,84.1s1.2,3.3,2,2.7-1-3.6-1-3.6S148.7,82.5,148.7,84.1Z",
    fill: "#fff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M140.9,87.9s1.2,3.4,2,2.8-1-3.6-1-3.6S140.9,86.3,140.9,87.9Z",
    fill: "#fff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M142.9,94.5c.8-4.5,7.6-4.4,11.7-4.1s4.7-5.3,4.7-5.3l4.6.6s1.6.6,1.7-1.3l.5-2.3a27.5,27.5,0,0,1-.3,9.1l-.7,4.5a88.7,88.7,0,0,1-11.9.2C148.3,95.5,142.9,94.5,142.9,94.5Z",
    fill: "url(#h)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M151.3,67.9c-.9,4.6-7.7,4.4-11.7,4s-4.8,5.2-4.8,5.2l-4.6-.7s-1.6-.7-1.8,1.3l-.5,2.2a27.3,27.3,0,0,1,.5-9l.7-4.6a93.2,93.2,0,0,1,11.9.1A101.9,101.9,0,0,1,151.3,67.9Z",
    fill: "url(#i)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M152.6,80.9s-2.4,5-2.5,9,.9,4,.3,5.2l.5.3.2-1.8s.3.6.1-1.2-1.1-1.2,2.1-10.9C153.3,81.5,153.8,80.9,152.6,80.9Z",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.4,66.8s-2.6-1.5-4.9,3.3-4.2-10.7-2.3-17.6c0,0-1.4-2.3-3.3,2.1-1.8,9.2-1.3,19-6.8,24.5C53,97.6,32.2,116,29,142l14.6,3.7s-2.6-10.4,8.6-28.5c8.5-13.8,15.1-22.5,20.7-27.5,4.1-3.7,7.7-4,10.8-9.3S88.4,66.8,88.4,66.8Z",
    fill: "#c27342"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.1,79.1c5.5-5.5,5-15.3,6.8-24.5a37.5,37.5,0,0,0-1.4,4.1s2.4-8.8.6-7.5-6.5,1.7-8,18.7c0,0-1.1,10.9-3.6,12.9s-32.1,29.6-35.3,40.6-3.5,18-3.5,18l2.3.6C32.2,116,53,97.6,71.1,79.1Z",
    fill: "#bc6734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,93.2c-.4-3,2.8-4.9,3.9-6.8l-7.8,2.7C92,89.4,93.4,91.1,94,93.2Z",
    fill: "#bc6734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,93.2a1.7,1.7,0,0,0,.1.7C94.1,93.7,94,93.4,94,93.2Z",
    fill: "#bc6734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,119c2.5-8.4,9.7-21.9,3.3-29.5a2.8,2.8,0,0,0-1.3-.4l-1.9.6s4.6,6.6,4,10.1c-2.2,12.8-12.8,34.6-12.9,52.9,0-1,.1-2.1.1-3.2C81.2,139.3,85,129,88.1,119Z",
    fill: "#bc6734"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7,161.4a217.9,217.9,0,0,1,5.4-61.5c.2-.5,5.4-14.9,1.1-22.9,0,0-2.2-.7-1.8,8.9l-1.5.5c-1.1,1.9-4.3,3.8-3.9,6.8,0,.2.1.5.1.7a1.7,1.7,0,0,1-.1-.7,5.7,5.7,0,0,0-2.6-3.7c6.4,7.6-.8,21.1-3.3,29.5-3.1,10-6.9,20.3-8.7,30.5,0,1.1-.1,2.2-.1,3.2s-.1,6-.1,6.3Z",
    fill: "#c27342"
  }))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M201.8,92.9c.5,1.6,1.2,3.2,2.1,3.4s.3-1.7-.4-3.7S201.3,91.3,201.8,92.9Z",
    fill: "#e7824f"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "197.1 86.4 194.2 85.7 193.9 86.9 195.5 86.9 196.8 87.6 197.1 86.4",
    fill: "#e7824f"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M185.3,88.5c-1.4,1.3-2.4,2.6-1.6,2.8s1.9-.7,3-1.7S187,86.9,185.3,88.5Z",
    fill: "#e7824f"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M207.7,82.6a8.5,8.5,0,0,0-10.5,1.7l-2.2-.2-.4,1.6s1.3,0,1.8,1.8,2.7,5.3,5.2,5.9,8.1-2.9,9.7-8.2C211.3,85.2,210.7,84.1,207.7,82.6Z",
    fill: "url(#k)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M202,91.9c-1.7-.5-3.5-3.2-4-4.9a3.7,3.7,0,0,1-.2-.9h0l.6-.5c2-2.1,4.2-2.8,6.7-2.1a6.2,6.2,0,0,1,1.7.6h.2a5.3,5.3,0,0,1,1.8,1.3C207.1,89.6,203.4,92.2,202,91.9Z",
    fill: "#395c6e"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M186.7,77.3a8.5,8.5,0,0,1,8.3,6.5l2.1.8-.3,1.6a2.4,2.4,0,0,0-2.6.7c-1.3,1.3-4.8,3.5-7.3,2.8s-5.7-6.4-4.7-11.8C182.2,77.9,183.3,77.1,186.7,77.3Z",
    fill: "url(#l)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M187.3,88.1c1.6.5,4.6-1.1,5.8-2.3a4.2,4.2,0,0,0,.6-.8h0l-.2-.8a6.7,6.7,0,0,0-5-5,4.8,4.8,0,0,0-1.8-.2h-.1a3.9,3.9,0,0,0-2.3.3C183.9,83.8,185.9,87.8,187.3,88.1Z",
    fill: "#395c6e"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M196.1,32.8s2,14.4-.4,19.4-11.2,4-12.2,8.7,3.2,5.9,13.1,3.3S207.5,53,207.5,53l-.3-20.8S199.3,30.7,196.1,32.8Z",
    fill: "url(#m)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.4,37s2,14.4-.4,19.4-11.1,4-12.2,8.7,3.2,5.9,13.1,3.3,10.9-11.2,10.9-11.2l-.3-20.8S202.6,34.9,199.4,37Z",
    fill: "#e2e6ec"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 201.9,
    y: 36.1,
    width: 0.3,
    height: 16.87,
    transform: "translate(-0.1 0.7) rotate(-0.2)",
    fill: "#bbc7d0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 204.9,
    y: 35.9,
    width: 0.3,
    height: 16.89,
    transform: "translate(-0.7 3.3) rotate(-0.9)",
    fill: "#bbc7d0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 207.8,
    y: 36,
    width: 0.3,
    height: 16.66,
    transform: "translate(-0.2 0.9) rotate(-0.3)",
    fill: "#bbc7d0"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M202.3,103.9c-.5-1.2-2-4.3-4-4.8l-1.5-.4h-.5l-1.6-.4c-2-.5-4.7,1.5-5.8,2.4l-7.5-1.9-.4,1.5-4.1,16,28.6,7.2,4.4-17.6Z",
    fill: "url(#n)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.4,
    cy: 111,
    r: 6.5,
    fill: "none",
    stroke: "#003449",
    strokeMiterlimit: 10,
    strokeWidth: 0.78
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 193.4,
    cy: 111,
    r: 4.7,
    fill: "url(#o)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M181.1,99.6s4.6,1.8,3.6,5.1-2.3,9.2-2.3,9.2-1.2,3.4-5.5,2.3C176.9,116.2,181.4,99.7,181.1,99.6Z",
    fill: "#003449"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M205.5,123.4s-4.6-1.8-3.6-5.1,2.3-9.2,2.3-9.2,1.2-3.4,5.4-2.3C209.6,106.8,205.1,123.3,205.5,123.4Z",
    fill: "#003449"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M184.7,100.3l.5-2.1-2.1-.5-.4,1.9A15,15,0,0,1,184.7,100.3Z",
    fill: "#98aab6"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 193.1,
    y: 99.7,
    width: 5.5,
    height: 1.94,
    transform: "translate(30.5 -44.8) rotate(14.1)",
    fill: "#bbc7d0"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7,132.2h0a2.7,2.7,0,0,0-2-3.4l-12-3-2.5-.6L172.1,122a2.7,2.7,0,0,0-3.3,2v.2l14,13.7Z",
    fill: "#e7824f",
    stroke: "#eea37a",
    strokeMiterlimit: 10,
    strokeWidth: 0.78
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7,132.2l-17.9,5.7-14-13.7c-.2,1.1-1.6,6.9-1.8,7.6a30.5,30.5,0,0,1-1.2,4.1,2.7,2.7,0,0,0,2,3.4l12,3,2.5.6,12.1,3.1a2.7,2.7,0,0,0,3.3-2,36.2,36.2,0,0,1,.9-4.2C198.8,139,200.3,133,200.7,132.2Z",
    stroke: "#eea37a",
    strokeLinejoin: "round",
    strokeWidth: 0.78,
    fill: "url(#p)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7,136.5l.4-1.3-2.1-.6-.3,1.4c-.3,0-.7.2-.7.5l-.3,1.2a.8.8,0,0,0,.3.8l-.3,1.3,2,.5.4-1.3a.8.8,0,0,0,.7-.5l.3-1.2A.7.7,0,0,0,183.7,136.5Z",
    fill: "#fdd058"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBeforeYouLeave, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/before-you-leave.95f25f08.svg";
export { ForwardRef as ReactComponent };